import React from "react";

import { MembranePrediction } from "constants/constantStrings";

import PopoverText from "components/PopoverText";

import "../index.scss";

export const CIT3PopoverMessage = () => {
  const getCIT3PopoverMessage = () => {
    return (
      <div>
        <h1>{MembranePrediction.detailedDescription}</h1>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.conductivityDetailledDescription1}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.conductivityDetailledDescription2}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.conductivityDetailledDescription3}
        </div>
      </div>
    );
  };
  return (
    <>
      <div>
        <span className="underline ">{MembranePrediction.detailedDescription}</span>
        <PopoverText
          descriptor={<span className="underline popover-text-descriptor">{MembranePrediction.detailedDescriptionMessage}</span>}
          descriptionText={getCIT3PopoverMessage()}
          customClass="summary-content"
        />
      </div>
    </>
  );
};

export const PT2PopoverMessage = () => {
  const getPT2PopoverMessage = () => {
    return (
      <div>
        <h1>{MembranePrediction.detailedDescription}</h1>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.pt2DetailedDescription1}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.pt2DetailedDescription2}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.pt2DetailedDescription3}
        </div>
      </div>
    );
  };
  return (
    <>
      <div>
        <span className="underline ">{MembranePrediction.detailedDescription}</span>
        <PopoverText
          descriptor={<span className="underline popover-text-descriptor">{MembranePrediction.detailedDescriptionMessage}</span>}
          descriptionText={getPT2PopoverMessage()}
          customClass="summary-content"
        />
      </div>
    </>
  );
};

export const DpPopoverMessage = () => {
  const getDPPopoverMessage = () => {
    return (
      <div>
        <h1>{MembranePrediction.detailedDescription}</h1>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.dpDetailedDescription1}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.dpDetailedDescription2}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {MembranePrediction.dpDetailedDescription3}
        </div>
        <div className="description">
          <span className="descriptionBold"> &#8226;&nbsp;</span>
          {MembranePrediction.dpDetailedDescription4}
        </div>
        <div className="description">
          <span className="descriptionBold"> &#8226;&nbsp;</span>
          {MembranePrediction.dpDetailedDescription5}
        </div>
      </div>
    );
  };
  return (
    <>
      <div>
        <span className="underline ">{MembranePrediction.detailedDescription}</span>
        <PopoverText
          descriptor={<span className="underline popover-text-descriptor">{MembranePrediction.detailedDescriptionMessage}</span>}
          descriptionText={getDPPopoverMessage()}
          customClass="summary-content"
        />
      </div>
    </>
  );
};
